import { render } from "./CampaignManageCreateForm.vue?vue&type=template&id=2be83219&lang=true"
import script from "./CampaignManageCreateForm.vue?vue&type=script&lang=js"
export * from "./CampaignManageCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__